/* eslint-disable no-console */
export function isEnvSwitcherEnabled(env: string) {
  return ['feqa-1', 'feqa-2', 'development'].includes(env);
}

export function getSelectedDevEnv(): string {
  return (
    localStorage.getItem('qaSelectedEnv') ??
    (import.meta.env.VITE_DEV_DEFAULT_API_ENV as string) ??
    'stage'
  );
}

type UrlType =
  | 'WEB_API_URL'
  | 'COLA_URL'
  | 'DASHBOARD_URL'
  | 'HOMEPAGE_URL'
  | 'GATEWAY_URL'
  | 'KEYCLOAK_REALM'
  | 'LEGACY_LOGIN_API';

export function getProcessEnvUrl(url: UrlType) {
  const fallback = import.meta.env[`VITE_${url}`];

  if (!isEnvSwitcherEnabled(import.meta.env.VITE_ENV ?? '')) {
    return fallback;
  }

  const selectedDevEnv = getSelectedDevEnv().toUpperCase().replace(/-/g, '_');

  const found = import.meta.env[`VITE_${selectedDevEnv}_${url}`];

  if (!found) {
    console.info(`VITE_${selectedDevEnv}_${url} not found.`);
  }

  return found ?? fallback;
}
